<template>
  <div class="main">
    <PromptGetPointModal ref="kubaoLotteryPrompt" />
    <TopCtrl />
    <Address
      ref="address"
      :address="address"
      :defaultAddress="defaultAddress"
      @onAddressReload="loadAddressList"
    />
    <!-- @onAddressSelected="onAddressChange" -->

    <div class="cart-list">
      <CartItem
        v-for="c in cartList"
        :key="c.cartId"
        :cart="c"
        @selectedChange="cartSelectedChange"
        @amountChange="cartAmountChange"
      />
    </div>

    <InfoList :info="info" v-if="currAddress" />

    <div class="cart-foot">
      <div class="right">
        <span class="sum" v-if="info.ready && info.valid">
          合计：
          <span class="num">{{ info.payPoint }}</span>
          {{ pointUnit }}
        </span>
        <template v-if="info.valid && currAddress">
          <template v-if="easyUser">
            <a
              href="javascript:;"
              class="action-btn m-button"
              @click="takeOrder"
              >{{ info.ready ? "确认兑换" : "计算中" }}</a
            >
          </template>
          <template v-else>
            <a
              href="javascript:;"
              class="action-btn disable"
              v-if="info.payPoint && info.balancePoint < info.payPoint"
              >余额不足</a
            >
            <a
              href="javascript:;"
              class="action-btn m-button"
              @click="takeOrder"
              :disabled="!info.ready"
              v-else
              >{{ info.ready ? "确认兑换" : "计算中" }}</a
            >
          </template>
        </template>
        <template v-else>
          <a href="javascript:;" class="action-btn disable">确认兑换</a>
        </template>
      </div>
      <div class="left">
        <CheckboxButton
          ref="selectAllBtn"
          @onChange="selectAll"
          :value="true"
        />全选
      </div>
    </div>

    <!-- 兑换获取碎片和星星 -->
    <ModalMask v-if="showMask" />
    <transition name="bounce">
      <PrizeModal v-if="showPrize && active && !easyUser && enableLottery" @close="cloasPrizeModal" :prize="prize" />
    </transition>
    <Star ref="stars" @close="handleStarClose" />

    <TabBar active="index"></TabBar>
  </div>
</template>
<script>
import api from "../../api";
import store from "../../api/store";
import Address from "@/components/payment/address";
import InfoList from "@/components/payment/info-list";
import CartItem from "@/components/orders/CartItem";
import ActionButton from "@/components/products/form/ActionButton";
import PromptGetPointModal from "@/components/kubaolottery/PromptGetPointModal";

// Modal
import success from "@/components/common/Modal/success";
import fail from "@/components/common/Modal/fail";

// 兑换碎片和星星

import PrizeModal from "@/components/common/Modal/PrizeModal.vue";
import ModalMask from "@/components/common/Modal/ModalMask.vue";
import Star from "@/components/common/Modal/Star.vue";
import { IEVersion } from "../../tools/IEVersion/IEVersion";
var loadOrderInfoTimer, cartAmountTimer;

export default {
  title: "结算页",
  bodyClass: "gray-bg",
  components: {
    Address,
    CartItem,
    ActionButton,
    InfoList,
    success,
    fail,
    PrizeModal,
    ModalMask,
    Star,
    PromptGetPointModal,
  },
  data() {
    return {
      active: store.active,
      enableLottery: store.loginedUser.enableLottery,

      prize: 0,
      showPrize: false,
      showMask: false,
      showStart: false,
      easyUser: store.loginedUser.easyUser,
      pointUnit: store.loginedUser.config.pointName,
      isModalShow: false,
      prize: 0,
      ui: {
        show: false,
      },
      address: [],
      currAddress: null,
      info: {
        ready: false,
        delivery: "快递",
        balancePoint: 0,
        payPoint: 0,
        valid: true,
        feeList: [],
      },
      cartList: [
        // {
        //     product: {
        //         productId: 0,
        //         name: '好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品',
        //         image: 'https://img10.360buyimg.com/mobilecms/s250x250_jfs/t22234/32/1947155483/115874/16bfee6c/5b3df187N78aa7a78.jpg',
        //         skuName: '高级',
        //         price: 2000
        //     },
        //     amount: 1,
        //     steps: [],
        //     isSelected: false,
        //     valid: true
        // }
      ],
      cartType: "product", //购物车类型， product实体商品，gold换金
      machineSn: "",
      defaultAddress: [],
    };
  },
  methods: {
    // 获取默认地址
    getDefault() {
      var address = this.$route.query.address
        ? this.$route.query.address
        : this.address.length
        ? this.address[0].id
        : null;
      api.order.getDefault(address, (res) => {
        this.defaultAddress = res.address;
        this.currAddress = res.address;
        this.loadOrderInfo();
        console.log(this.defaultAddress.id);
        // if (this.address.length && !res.address) {
        //   api.order.setDefault(this.address[0].id, (res) => {
        //     alert("1");
        //     // this.loadAddressList()
        //   });
        // }
      });
    },
    loadAddressList() {
      api.order.getJingdongAddressList((res) => {
        this.address = [];
        //排序地址，将最后创建的地址排在前面
        var addressList = res.addresses.sort((a, b) => {
          return b.id - a.id;
        });
        addressList.forEach((a) => {
          this.address.push(a);
        });
        var defaultSelectedAddress =
          this.address.length > 0 ? this.address[0] : null;
        if (defaultSelectedAddress == null) {
          this.$alertDialog("请先添加地址");
        }
        this.getDefault();
        this.$refs.address.setCurrAddress(defaultSelectedAddress);
        this.loadOrderInfo();
      });
    },
    loadOrderInfo() {
      console.log("loadOrderInfo...");
      clearTimeout(loadOrderInfoTimer);
      loadOrderInfoTimer = setTimeout(() => {
        //如果信息补全，结算信息为空
        var addressId = null,
          skuType = 2, //京东
          skus;
        if (!this.currAddress) {
          console.log("地址不全");
          return;
        }
        addressId = this.currAddress.id;

        var selectedCartList = this.cartList.filter((c) => c.isSelected);

        if (selectedCartList.length <= 0) {
          console.log("商品选择不全:" + this.cartList.length);
          if (!this.info.ready) {
            this.loadOrderInfo();
          }
          return;
        }

        var isAmountValid = true;
        skus = selectedCartList
          .map((c) => {
            if (!c.amount) {
              isAmountValid = false;
            }
            return c.product.productId + ":" + c.amount;
          })
          .join(",");

        if (!isAmountValid) {
          return;
        }

        //如果信息全了，显示结算信息

        this.info.ready = false;

        if (this.cartType == "product") {
          api.order.validateOrder(
            addressId,
            skuType,
            skus,
            (res) => {
              //   console.log(res);
              if (!res.valid) {
                this.$alertDialog("商品缺货，系统取消缺货商品", () => {
                  var validSkus = {};

                  this.cartList.forEach((c) => {
                    res.skus.forEach((s) => {
                      if (c.product.productId == s.skuId) {
                        c.valid = s.valid;
                        if (c.valid) {
                          validSkus[s.skuId] = true;
                        }
                      }
                    });
                  });

                  this.cartList.forEach((c) => {
                    if (validSkus[c.product.productId]) {
                      c.isSelected = true;
                    } else {
                      c.isSelected = false;
                    }
                  });

                  this.$toast("已取消缺货商品");
                });
              } else {
                this.cartList.forEach((c) => {
                  c.valid = true;
                });
              }
              this.info.ready = true;

              this.info.valid = res.valid;
              this.info.balancePoint = res.balancePoint;
              this.info.payPoint = res.payPoint;
              this.info.feeList = res.feeList;
            },
            (r) => {
              var msg = r.msg || "无法加载价格信息";
              this.$confirmDialogWithOpts(
                msg,
                "warn",
                ["返回购物车", "重新加载"],
                (btn) => {
                  if (btn == "返回购物车") {
                    this.$routerReplace(this, "/pages/orders/Cart");
                  } else if (btn == "重新加载") {
                    this.loadOrderInfo();
                  }
                }
              );
            }
          );
        } else if (this.cartType == "gold") {
          api.order.validateJingdongGold(
            addressId,
            this.cartList[0].amount,
            this.cartList[0].product.productId,
            (res) => {
              //   console.log(res);
              if (!res.valid) {
                var validSkus = {};

                this.cartList.forEach((c) => {
                  res.skus.forEach((s) => {
                    if (c.product.productId == s.skuId) {
                      c.valid = s.valid;
                      if (c.valid) {
                        validSkus[s.skuId] = true;
                      }
                    }
                  });
                });

                this.$toast("当前数量已缺货，请重新选择数量");
              } else {
                this.cartList.forEach((c) => {
                  c.valid = true;
                });
              }
              this.info.ready = true;

              this.info.valid = res.valid;
              this.info.balancePoint = res.balancePoint;
              this.info.payPoint = res.payPoint;
              this.info.feeList = res.feeList;
            },
            (r) => {
              var msg = r.msg || "无法加载价格信息";
              this.$confirmDialogWithOpts(
                msg,
                "warn",
                ["返回购物车", "重新加载"],
                (btn) => {
                  if (btn == "返回购物车") {
                    this.$routerReplace(this, "/pages/orders/Cart");
                  } else if (btn == "重新加载") {
                    this.loadOrderInfo();
                  }
                }
              );
            }
          );
        }
      }, 500);
    },
    showModal() {
      this.isModalShow = true;
    },
    showAddress() {
      this.ui.show = true;
    },
    cartSelectedChange(cart, isSelect) {
      cart.isSelected = isSelect;
      this.loadOrderInfo();
    },
    cartAmountChange(cart, amount) {
      cart.amount = amount;
      clearTimeout(cartAmountTimer);
      cartAmountTimer = setTimeout(() => {
        if (this.cartType == "product") {
          api.cart.addCart(cart.product.productId, amount, true, (res) => {
            this.loadOrderInfo();
          });
        } else {
          this.loadOrderInfo();
        }
      }, 100);
    },
    selectAll(isSelectAll) {
      this.cartList.forEach((c) => {
        c.isSelected = isSelectAll;
      });
    },
    showAddressList() {
      this.ui.show = true;
    },
    closeAddressList() {
      this.ui.show = false;
    },
    select(address) {
      this.curr = address;
      this.closeAddressList();
    },
    showAddAddress() {
      this.$refs.addAdress.show();
    },
    // onAddressChange(address) {
    //   this.currAddress = address;
    //   console.log(address);
    //   this.loadOrderInfo();
    // },
    takeOrder() {
      //如果信息补全，结算信息为空
      var addressId = null,
        skuType = 2, //京东
        skus;
      if (!this.currAddress) {
        this.$toast("请填写地址");
        return;
      }
      addressId = this.currAddress.id;

      var selectedCartList = this.cartList.map((c) => {
        if (c.isSelected) {
          return c;
        }
      });

      if (selectedCartList.length <= 0) {
        this.$toast("请选择商品");
        return;
      }

      skus = selectedCartList
        .map((c) => {
          return c.product.productId + ":" + c.amount;
        })
        .join(",");

      // TODO： 大玩家用户直接兑换

      if (this.easyUser) {
        // 是大玩家用户
        this.$confirmDialog("确定兑换？", (btn) => {
          if (btn == "确定") {
            if (this.cartType == "product") {
              console.log(`直接请求大玩家的接口`);
              this.$showLoading("兑换中...");
              //费用列表，将结算页的feeList按 type:point,type:point的格式传
              var feeList = this.info.feeList
                .map((i) => {
                  return i.type + ":" + i.point;
                })
                .join(",");
              if (!feeList) {
                this.$hideLoading();
                return;
              }

              api.easy.easyOrderTake(
                addressId,
                feeList,
                this.info.payPoint,
                skuType,
                skus,
                (res) => {
                  //   console.log(res);
                  this.$hideLoading();
                  var hours = res.orderValidTimeMinute / 60;

                  this.$confirmDialogWithOpts(
                    `提交订单成功,请在联系场地确认,超过${hours}小时未确认，订单将失效`,
                    "success",
                    ["我知道了", "查看订单"],
                    (btn) => {
                      if (btn == "我知道了") {
                        //Do nothing
                      } else if (btn == "查看订单") {
                        this.$routerReplace(this, "/pages/orders/List");
                      }
                    }
                  );
                },
                (res) => {
                  //   console.log(res);
                  this.$hideLoading();

                  if (res.status == -1) {
                    this.$alertDialog(res.msg, () => {});
                  } else {
                    this.$confirmDialogWithOpts(
                      "还有订单未确认，继续下单请确认或取消",
                      "error",
                      ["我知道了", "去订单管理"],
                      (btn) => {
                        if (btn == "我知道了") {
                          //Do nothing
                        } else if (btn == "去订单管理") {
                          //Do nothing
                          this.$routerReplace(this, "/pages/orders/List");
                        }
                      }
                    );
                  }
                }
              );
            } else if (this.cartType == "gold") {
              //费用列表，将结算页的feeList按 type:point,type:point的格式传
              var feeList = this.info.feeList
                .map((i) => {
                  return i.type + ":" + i.point;
                })
                .join(",");
              if (!feeList) {
                this.$hideLoading();
                return;
              }
              var arr = skus.split(":");
              //   console.log(arr);
              var skuId = arr[0];
              var count = arr[1];
              api.easy.easyOrderTakeJingdongGold(
                addressId,
                count,
                feeList,
                this.info.payPoint,
                skuId,
                (res) => {
                  //   console.log(res);
                  this.$hideLoading();

                  this.$confirmDialogWithOpts(
                    "兑换成功",
                    "success",
                    ["我知道了", "查看订单"],
                    (btn) => {
                      if (btn == "我知道了") {
                        //Do nothing
                      } else if (btn == "查看订单") {
                        this.$routerReplace(this, "/pages/orders/List");
                      }
                    }
                  );
                },
                (res) => {
                  //   console.log(res);
                  this.$hideLoading();

                  if (res.status == -1) {
                    this.$alertDialog(res.msg, () => {});
                  } else {
                    this.$confirmDialogWithOpts(
                      "还有订单未确认，继续下单请确认或取消",
                      "error",
                      ["我知道了", "去订单管理"],
                      (btn) => {
                        if (btn == "我知道了") {
                          //Do nothing
                        } else if (btn == "去订单管理") {
                          //Do nothing
                          this.$routerReplace(this, "/pages/orders/List");
                        }
                      }
                    );
                  }
                }
              );
            }
          }
        });

        return;
      }

      //如果信息全了，显示结算信息

      this.$confirmDialog("确定兑换？", (btn) => {
        if (btn == "确定") {
          this.$showLoading("支付中...");
          var feeList = this.info.feeList
            .map((i) => {
              return i.type + ":" + i.point;
            })
            .join(","); //费用列表，将结算页的feeList按 type:point,type:point的格式传
          if (!feeList) {
            this.$hideLoading();
            return;
          }

          if (this.cartType == "product") {
            api.order.takeOrder(
              addressId,
              skuType,
              skus,
              this.info.payPoint,
              feeList,
              this.machineSn,
              (res) => {
                if (res.presentShredCount) {
                  store.present = res.presentShredCount;
                  this.prize = res.presentShredCount;
                  var isIE = IEVersion();
                  if (isIE == "-1") {
                    // -1 表示非IE浏览器
                    this.handleShowPrizeModal();
                  }
                } else {
                  store.present = 0;
                }
                this.$confirmDialogWithOpts(
                  "兑换成功",
                  "success",
                  ["查看订单", "继续兑换"],
                  (btn) => {
                    if (btn == "查看订单") {
                      this.$routerReplace(
                        this,
                        "/pages/orders/Detail?orderno=" + res.orderno
                      );
                    } else if (btn == "继续兑换") {
                      //Do nothing
                    }
                  }
                );
                this.$hideLoading();
              },
              (err) => {
                this.$hideLoading();
                if (
                  err.status == -46 &&
                  this.user.kkbUser &&
                  this.user.kubaoLotteryLoginUrl &&
                  this.$refs.kubaoLotteryPrompt.needNotify()
                ) {
                  //积分不足
                  this.$refs.kubaoLotteryPrompt.display();
                } else {
                  this.$alertDialog(err.msg);
                }
              }
            );
          } else if (this.cartType == "gold") {
            api.order.takeJingdongGold(
              addressId,
              this.cartList[0].amount,
              this.cartList[0].product.productId,
              this.info.payPoint,
              feeList,
              this.machineSn,
              (res) => {
                if (res.presentShredCount) {
                  store.present = res.presentShredCount;
                } else {
                  store.present = 0;
                }
                this.$confirmDialogWithOpts(
                  "兑换成功",
                  "success",
                  ["查看订单", "继续兑换"],
                  (btn) => {
                    if (btn == "查看订单") {
                      this.$routerReplace(
                        this,
                        "/pages/orders/Detail?orderno=" + res.orderno
                      );
                    } else if (btn == "继续兑换") {
                      //Do nothing
                    }
                  }
                );
                this.$hideLoading();
              },
              (err) => {
                this.$hideLoading();
                if (
                  err.status == -46 &&
                  this.user.kkbUser &&
                  this.user.kubaoLotteryLoginUrl &&
                  this.$refs.kubaoLotteryPrompt.needNotify()
                ) {
                  //积分不足
                  this.$refs.kubaoLotteryPrompt.display();
                } else {
                  this.$alertDialog(err.msg);
                }
              }
            );
          }
        }
      });
    },
    handleShowPrizeModal(prize) {
      this.prize = prize;
      this.showMask = true;
      this.showPrize = true;
    },
    cloasPrizeModal() {
      this.showPrize = false;
      setTimeout(() => {
        this.$refs.stars.startAnimation();
      }, 0.8 * 1000);
    },
    handleStarClose() {
      this.showMask = false;
    },
  },
  computed: {
    curr() {
      return this.address;
    },
    sum() {
      var total = 0;
      this.cartList.forEach((c) => {
        if (c.isSelected) {
          total += c.amount * c.product.price;
        }
      });
      return total;
    },
  },
  mounted() {
    var cart = this.$route.query.cart;
    var cartList = [];
    cart.split(",").forEach((cartStr) => {
      var cartItem = cartStr.split("-");
      cartList.push({
        skuId: cartItem[0],
        amount: cartItem[1],
      });
    });

    var skuIds = cartList.map(function (c) {
      return c.skuId;
    });

    api.product.getProductList(skuIds, (res) => {
      // console.log(res);

      if (res.list.length <= 0) {
        this.$alertDialog("你选中的商品暂时无法兑换", () => {
          this.$routerReplace(this, "/pages/homepage/Index");
        });
        return;
      }

      res.list.forEach((l) => {
        var selectedSku = cartList.filter((c) => {
          if (c.skuId == l.skuId) {
            return c.amount;
          }
        })[0];

        var steps = [];

        if (l.type == 4) {
          this.cartType = "gold";
          steps = l.jingdongGoldBuyCounts;
        }

        this.cartList.push({
          product: {
            productId: l.skuId,
            name: l.title,
            image: l.image,
            skuName: l.name,
            price: l.price,
          },
          amount: parseInt(selectedSku.amount),
          steps,
          isSelected: true,
          valid: true,
        });
      });
    });

    this.loadAddressList();
    // this.getDefault()
    this.machineSn = this.$route.query.machineSn;
  },
};
</script>
<style scoped lang="less">
.main {
  padding: 2.67vw;
}
.cart-list {
  background: #fff;
  margin-top: 2.67vw;
  border-radius: 4px;
}
.info-list {
  margin: 0;
  border-radius: 4px;
}
.cart-foot {
  position: fixed;
  z-index: 11;
  bottom: 13.733vw;
  left: 0;
  right: 0;
  height: 13.33vw;
  line-height: 13.33vw;
  border-top: 1px solid #c1c1c1;
  border-bottom: 1px solid #c1c1c1;
  background: #fff;
  font-size: 3.46vw;
  .left {
    padding-left: 4vw;
    color: #666;
  }
  .right {
    float: right;
    color: #000;
    font-size: 0;
    padding-right: 28vw;
    .sum {
      font-size: 3.46vw;
      text-align: right;
      .num {
        color: @themeColor;
        padding: 0 0.3em;
      }
    }
    .action-btn {
      display: inline-block;
      background-image: linear-gradient(to right, #ff0d33, #ff7f5f);
      color: #fff;
      width: 27.6vw;
      text-align: center;
      font-size: 3.46vw;
      border: 0;
      margin: 0;
      padding: 0;
      position: absolute;
      z-index: 12;
      top: 0.25vw;
      right: 0;

      &.disable {
        background-image: linear-gradient(to right, #999, #aaa);
      }
    }
  }
}

.address-float-box {
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f2f2f2;
  .title {
    color: #000;
    text-align: center;
    font-size: 4.266vw;
    line-height: 3em;
  }
  .icon-dialog-close {
    width: 2.8vw;
    height: 2.8vw;
    position: fixed;
    z-index: 21;
    top: 5.2vw;
    right: 4vw;
  }
  .address {
    background: #fff;
    border-radius: 2.4vw;
    padding: 6vw;
    width: 91.73vw;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    margin: 4vw auto;
    position: relative;
    .reciever,
    .contact {
      display: inline-block;
      line-height: 1em;
      margin-bottom: 2.66vw;
      margin-right: 4.8vw;
      color: #333;
    }
    .detail {
      color: #666666;
      font-size: 3.733vw;
    }
    .delete-btn {
      display: inline-block;
      font-size: 3.46vw;
      width: 4em;
      position: absolute;
      top: 5.86vw;
      right: 4.8vw;
      color: #3c3c3c;
      .icon {
        height: 4.26vw;
        width: 4.26vw;
        display: inline-block;
        vertical-align: top;
      }
    }
    &.selected {
      background: #ff9933;
      .reciever,
      .contact {
        color: #fff;
      }
      .detail {
        color: #fff;
      }
      .delete-btn {
        color: #fff;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/payment/Payment.vue